import { Components, Theme } from '@mui/material';

const MuiButton: Components<Theme>['MuiButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: theme.fontSizes.regular,
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: '16px',
      textTransform: 'none',
    }),
  },
  variants: [
    {
      props: {
        variant: 'contained',
      },
      style: {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none',
        },
      },
    },
    {
      props: {
        color: 'primary',
        variant: 'contained',
      },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.grey[900],
        '&:hover': {
          backgroundColor: theme.palette.grey[800],
          color: theme.palette.primary.contrastText,
        },
        '&:disabled': {
          backgroundColor: theme.palette.grey[400],
          color: theme.palette.common.white,
        },
      }),
    },
    {
      props: {
        color: 'primary',
        variant: 'contained',
        loading: true,
      },
      style: {
        '& .MuiButton-loadingIndicator': {
          color: 'white',
        },
      },
    },
    {
      props: {
        color: 'primary',
        variant: 'outlined',
      },
      style: ({ theme }) => ({
        borderColor: theme.palette.grey[300],
        color: theme.palette.grey[900],
        '&:hover': {
          borderColor: theme.palette.grey[400],
          backgroundColor: 'transparent',
          color: theme.palette.grey[900],
        },
      }),
    },
    {
      props: {
        size: 'large',
      },
      style: ({ theme }) => ({
        padding: theme.spacing(theme.spacingSizes.xs, theme.spacingSizes.lg),
      }),
    },
  ],
};

export default MuiButton;
